/** 回购 */
<template>
  <div class="commit-withdrawal-wrap">
    <BasiceLayout
      title="兑换申请"
      class="bonus-code-layout margin-top-20"
    >
      <el-row v-if="balance !== 'NONE'">
        <!-- 兑换面额选择 -->
        <el-col :span="10">
          <div class="common-left-wrap">
            <div class="withdrawal-key balance-distance">请选择兑换面额</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <el-select
            v-model="JDCardMoney"
            placeholder="请选择"
            @change="queryLimit"
          >
            <el-option
              v-for="item in canExchangeMoney"
              :key="item"
              :label='item + "元"'
              :value="item"
            >
            </el-option>
          </el-select>
          <span v-if="!exchangeStatus" class="exchange-tips bonus-tips">今日兑换额度已用完</span>
        </el-col>
      </el-row>
      <!-- 兑换张数 -->
      <el-row>
        <el-col :span="10">
          <div class="common-left-wrap">
            <div class="withdrawal-key last-price-key">请选择兑换张数</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <el-select
            v-model="JDCardCount"
            placeholder="请选择"
          >
            <!-- v-if="count > 0" -->
            <el-option
              v-for="item in exchangeCountList"
              :key="item"
              :label='item + "张"'
              :value="item"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 要兑换的JD卡总额为 -->
      <el-row>
        <el-col :span="10">
          <div class="common-left-wrap">
            <div class="withdrawal-key last-price-key">要兑换的JD卡总额为</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <div v-if="exchangeJDMoney !== 'OVER_AMMOUNT'">{{exchangeJDMoney ? (exchangeJDMoney + '元') : '-'}}</div>
          <div
            class="bonus-tips"
            v-if="exchangeJDMoney === 'OVER_AMMOUNT'"
          >兑换张数超出额度</div>
        </el-col>
      </el-row>
      <!-- 当前BxC兑换价 -->
      <el-row>
        <el-col :span="10">
          <div class="common-left-wrap">
            <div class="withdrawal-key last-price-key">当前BXC兑换价</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <div>{{RMBPrice + ' 元' || '-'}}</div>
        </el-col>
      </el-row>
      <!-- 需要BxC数量 -->
      <el-row>
        <el-col :span="10">
          <div class="common-left-wrap">
            <div class="withdrawal-key last-price-key">需要BXC数量</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <div>{{needBXCCount ? (needBXCCount + 'BXC') : '-'}}</div>
        </el-col>
      </el-row>
      <!-- 账户余额 -->
      <el-row>
        <el-col :span="10">
          <div class="common-left-wrap">
            <div class="withdrawal-key last-price-key">账户余额</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <div>{{balance + 'BXC' || '-'}}</div>
        </el-col>
      </el-row>
      <!-- 验证 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="verify-key withdrawal-key">{{$t('withdrawal.commitWith.verify')}}</div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <vue-recaptcha
            class="captcha-wrap"
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            data-size="normal"
            :sitekey="sitekey"
          />
        </el-col>
      </el-row>
      <!-- 验证码 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="withdrawal-key email-key">{{$t('withdrawal.commitWith.emailCode')}}</div>
        </el-col>
        <el-col
          :span="14"
          class="common-right-wrap"
        >
          <SendEmailCode
            class="send-wrap withdrawal-value"
            v-model="inputEmailCode"
            :response="response"
            :email="email"
            @emailCodeTip="emailCodeTip"
          ></SendEmailCode>
        </el-col>
      </el-row>
      <div
        v-if="balance !== 'NONE'"
        class="buttonWrap"
      >
        <div
          class="button "
          @click="commit"
        >{{$t('confirm')}}</div>
      </div>
    </BasiceLayout>

  </div>
</template>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import TencentVerify from "@/components/Common/TencentVerify.vue";
import SendEmailCode from "@/components/SendEmailCode.vue";
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import { messageTips } from "../../../utils/tips.js";
import { SITEKEY } from "../../../config/contant.js";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "AccountLayout",
  props: {},
  components: {
    BasiceLayout,
    TencentVerify,
    SendEmailCode,
    VueRecaptcha
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    email: state => state.account.email,
    balance: state => state.exchange.balance,
    // 当前BXC兑换价
    RMBPrice: state => state.exchange.RMBPrice,
    // 可选兑换面额
    canExchangeCount: state => state.exchange.canExchangeCount,
    // 可选兑换张数list
    canExchangeMoney: state => state.exchange.canExchangeMoney,
    // 计算可选兑换张数
    exchangeCountList() {
      let { JDCardMoney, canExchangeCount } = this;

      if (JDCardMoney && canExchangeCount[JDCardMoney]) {
        return canExchangeCount[JDCardMoney];
      } else {
        return [];
      }
    },
    //要兑换的JD卡总额
    exchangeJDMoney() {
      let { JDCardCount, JDCardMoney, balance, RMBPrice } = this;
      let money = JDCardCount * JDCardMoney;

      if (money > balance * RMBPrice) {
        return "OVER_AMMOUNT";
      } else {
        return money;
      }
    },
    // 需要BXC数量
    needBXCCount() {
      let { exchangeJDMoney, balance, RMBPrice } = this;

      if (exchangeJDMoney && exchangeJDMoney !== "OVER_AMMOUNT") {
        return Math.ceil(exchangeJDMoney / RMBPrice);
      } else {
        return "";
      }
    }
  }),
  data() {
    return {
      exchangeStatus: true, //兑换状态
      // JDCardList, //京东兑换面额
      // maxCount: '', //根据余额计算的最大兑换张数
      exchangeCount: "", //兑换张数
      inputEmailCode: "",
      // 选中京东面额
      JDCardMoney: "",
      // 选中京东数额
      JDCardCount: "",
      //   ticket: "",
      //   csnonce: "",
      //   amount: "",
      //   showAddressDialog: false,
      response: "",
      sitekey: SITEKEY["LOW"] //ga verify key
    };
  },
  created() {
    this.getExchangeInfo();
  },
  methods: {
    ...mapActions([
      //   "commitBuyBack",
      //   "getWithdrawalList",
      "getExchangeInfo",
      "commitExchange",
      "getExchangeList",
      "getLimitExchange"
      //   "getBuybackAddress",
      //   "getBuyBackList"
    ]),
    // 查询限额
    queryLimit() {
      let { JDCardMoney } = this;

      this.getLimitExchange({ JDCardMoney }).then(res => {
        if (res.code !== 200) {
          this.exchangeStatus = false;
        } else {
          this.exchangeStatus = true;
        }
      });

      console.log(JDCardMoney);
    },

    onVerify: function(response) {
      this.response = response;
    },
    onExpired: function() {
      Message({
        message: this.$t("captcha.expired"),
        type: "error"
      });
      this.$refs.recaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
    },
    emailCodeTip(error) {
      if (error.message) {
        Message({
          type: "error",
          message: error.message
        });
      }
    },
    // update 验证ticket
    changeTicket(verify) {
      verify.ticket && (this.ticket = verify.ticket);
      verify.csnonce && (this.csnonce = verify.csnonce);
    },
    commit() {
      let {
        inputEmailCode,
        JDCardMoney,
        JDCardCount,
        exchangeJDMoney,
        needBXCCount,
        RMBPrice
      } = this;


      if (!inputEmailCode) {
        Message({
          type: "error",
          message: "缺少手机验证码" || "network error"
        });
      } else if (!JDCardMoney || !JDCardCount) {
        messageTips("limit_exchange_param");
      } else {
        this.$confirm(
          `您确定要使用 ${needBXCCount} BxC 兑换 ${JDCardCount} 张 面额为 ${JDCardMoney}元的 JD卡吗？`,
          {
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel")
          }
        ).then(() => {
          this.commitExchange({
            JDCardMoney,
            JDCardCount,
            exchangeJDMoney,
            needBXCCount,
            RMBPrice,
            emailVerifyCode: inputEmailCode
          }).then(res => {
            if (res.code === 200) {
              Message({
                type: "success",
                message: "提交成功，等待处理"
              });
              this.getExchangeList();
            } else {
              Message({
                type: "error",
                message: res.message || "network error"
              });
            }
          });
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">


.addr-status {
  margin: 40px;
  color: #909399;
}

.last-price-key {
  margin: 10px 0;
}

.commit-withdrawal-wrap .bonus-code-layout .captcha-wrap{
  margin : 0
}

.exchange-tips{
  font-size: 12px;
  margin-left: 20px;
}
</style>

